import { Clipboard } from "@angular/cdk/clipboard";
import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IGenericResponse } from "src/models/genericModels";
import { ReferralInfo, ReferralInfoResponse } from "src/models/referral";
import { CommonService } from "src/services/common.service";
import { ReferralService } from "src/services/referral.service";

@Component({
  selector: "app-refer-and-earn-modal",
  standalone: false,
  templateUrl: "./refer-and-earn-modal.component.html",
  styleUrl: "./refer-and-earn-modal.component.scss",
})
export class ReferAndEarnModalComponent implements OnInit {
  data!: ReferralInfo;
  code: string = "";

  constructor(
    private referralService: ReferralService,
    public dialogRef: MatDialogRef<ReferAndEarnModalComponent>,
    @Inject(MAT_DIALOG_DATA) public res: any,
    private clipboard: Clipboard,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.getReferralInfo();
  }

  getReferralInfo() {
    this.referralService.fetchRefferalInfo().subscribe({
      next: (res: ReferralInfoResponse) => {
        this.data = res.data;
        console.log("Referral Info:", res.data);
      },
      error: (err) => {
        console.error("Referral Info Error:", err);
      },
    });
  }

  applyCode() {
    if (this.code.length >= 4) {
      this.referralService
        .applyReferralCode(this.code.toUpperCase())
        .subscribe({
          next: (res: IGenericResponse) => {
            this.commonService.openSnackbar(res.message);
            this.closeModal();
            console.log("Add Referral:", res);
          },
          error: (err) => {
            this.commonService.openSnackbar(
              err.error.message ?? err.error.detail
            );
            console.error("Add Referral Error:", err);
          },
        });
    }
  }

  copyText(text: string) {
    this.clipboard.copy(text);
  }

  closeModal() {
    this.dialogRef.close();
  }
}
